import { render, staticRenderFns } from "./CrossSell.vue?vue&type=template&id=62d56f9a&"
import script from "./CrossSell.vue?vue&type=script&lang=js&"
export * from "./CrossSell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports